'use strict';

import * as THREE from "three";
import {isMobile, settingsData, threeJsVariables} from '../../settings';
import gsap from "gsap";
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { LinearEncoding, DoubleSide, MeshBasicMaterial} from 'three';
import {lazyLoadingData} from "../../functions";
import { FrontSide } from 'three';
import { sRGBEncoding } from 'three';
import { TextureLoader } from 'three';


export async function sphereBackground () {
    const {cdnRepository,projectFolder} = config;
    const {imageCdnQualityUrl,staticFolder} = config.resources.background;
    const loader = new FBXLoader();
    const textureLoader = new TextureLoader();
    let imgUrl;

    if (staticFolder){
        imgUrl = `${cdnRepository}/${projectFolder}/resources/textures/background/${isMobile? 'mobile' : 'desktop'}`
    } else {
        imgUrl = `${cdnRepository}/${isMobile?imageCdnQualityUrl.mobile:imageCdnQualityUrl.desktop}/${projectFolder}/resources/textures/background`;
    }

    const model = await lazyLoadingData(loader,`/assets/model/sphere/sphere_360.fbx`);

    model.traverse(el=>{
       if (el.isMesh){
           const materialName = el.material.name;
           const material = new MeshBasicMaterial({
               map: textureLoader.load(`${imgUrl}/${materialName}.jpg`),
               side: FrontSide,
               color: 0xffffff,
           });
           el.material = material;
           el.material.map.encoding = LinearEncoding;
       }
    });

    const {position,rotation,scale} = config.resources.background;

    model.name = 'Background';

    model.position.set(position.x,position.y,position.z);
    model.rotation.set (rotation.x,rotation.y,rotation.z);
    model.scale.set(scale.x,scale.y,scale.z);

    threeJsVariables.scene.add(model);
}


export function sceneBackground(action) {
    const pathCdn = isMobile
        ? config.imageCdnQualityUrl.mobile
        : config.imageCdnQualityUrl.desktop;
    const pathUrl = pathCdn + 'resources/textures/background/';

    const backgroundTexture = {
        current: [
            `${pathUrl}px.jpg`,
            `${pathUrl}nx.jpg`,
            `${pathUrl}py.jpg`,
            `${pathUrl}ny.jpg`,
            `${pathUrl}pz.jpg`,
            `${pathUrl}nz.jpg`
        ],
        // clear: [
        //     `${pathUrl}clear/px.jpg`,
        //     `${pathUrl}clear/nx.jpg`,
        //     `${pathUrl}clear/py.jpg`,
        //     `${pathUrl}clear/ny.jpg`,
        //     `${pathUrl}clear/pz.jpg`,
        //     `${pathUrl}clear/nz.jpg`
        // ],
    };

    if (action === 'BUILDING_ONLY'){
        if (Object.keys(settingsData.sceneBgContent.cylinder).length){
            return new Promise(resolve => resolve(settingsData.sceneBgContent.cylinder));
        }
    } else {
        if (Object.keys(settingsData.sceneBgContent.orbit).length){
            return new Promise(resolve => resolve(settingsData.sceneBgContent.orbit));
        }
    }

    const manager = new THREE.LoadingManager();
    manager.onLoad = function () {
       texture.then((response)=> {
           if (action === 'BUILDING_ONLY'){
               settingsData.sceneBgContent.cylinder = response;
           } else {
               settingsData.sceneBgContent.orbit = response;
           }
       });
    };

    const loaderCubeTexture = new THREE.CubeTextureLoader(manager);

    const texture = lazyLoadingData(loaderCubeTexture, (action === 'BUILDING_ONLY') ? backgroundTexture.clear : backgroundTexture.current);
    return texture;
}

export function setCylinderSceneBackground () {
    if (!threeJsVariables.scene.background.isColor){
        threeJsVariables.scene.background = new THREE.Color('#151515');
    }
}

export function loadSixBoxImages () {
    // const pathCdn = config.imageCdnQualityUrl;
    // const pathUrl = pathCdn + 'resources/textures/background/';
    //
    // const links = [
    //         `${pathUrl}px.jpg`,
    //         `${pathUrl}nx.jpg`,
    //         `${pathUrl}py.jpg`,
    //         `${pathUrl}ny.jpg`,
    //         `${pathUrl}pz.jpg`,
    //         `${pathUrl}nz.jpg`
    //     ];
    //
    // const promiseArray = [];
    const loader = new THREE.TextureLoader();
    //
    // links.forEach(link =>{
    //    const texture = lazyLoadingData(loader,link);
    //    promiseArray.push(texture);
    // });
    //
    return lazyLoadingData(loader,'resources/textures/background/360.jpg');
}

export function sphereSceneBackground (textures) {
    const {position,radius,rotation,scale} = config.background;
    const geometry = new THREE.SphereBufferGeometry(radius,50,50);
    const material = new THREE.MeshBasicMaterial({
        map: textures,
        side: THREE.BackSide,
    });
    // material.envMap.wrapS = THREE.RepeatWrapping;
    // material.envMap.wrapT = THREE.RepeatWrapping;
    // material.envMap.offset.set(0,0);
    // material.envMap.repeat.set(1,-1);
    // material.envMap.flipY = true;

    const mesh = new THREE.Mesh(geometry,material);
    mesh.position.set(position.x,position.y,position.z);
    mesh.rotation.set(rotation.x, rotation.y,rotation.z);
    mesh.scale.set(scale.x,scale.y,scale.z);
    mesh.name = 'Background';

    // textures.forEach(texture =>{
    //     const material = new THREE.MeshBasicMaterial({
    //         map: texture,
    //         side: THREE.BackSide
    //     });
    //     material.map.wrapS = THREE.RepeatWrapping;
    //     material.map.wrapT = THREE.RepeatWrapping;
    //     material.map.repeat.set(1,1);
    //     materialsArray.push(material);
    // });
    //
    // const mesh = new THREE.Mesh(geometry,materialsArray);
    // mesh.name = 'BoxBackground';
    // mesh.position.set(0,150,0);
    // mesh.rotation.set(0,-3.460,0);
    threeJsVariables.scene.add(mesh);
}



// export function sceneBackground(action) {
//     const pathUrl = './resources/textures/background/';
//
//     const backgroundTexture = {
//         current: [
//             `${pathUrl}px.jpg`,
//             `${pathUrl}nx.jpg`,
//             `${pathUrl}py.jpg`,
//             `${pathUrl}ny.jpg`,
//             `${pathUrl}pz.jpg`,
//             `${pathUrl}nz.jpg`
//         ],
//         clear: [
//             `${pathUrl}clear/px.jpg`,
//             `${pathUrl}clear/nx.jpg`,
//             `${pathUrl}clear/py.jpg`,
//             `${pathUrl}clear/ny.jpg`,
//             `${pathUrl}clear/pz.jpg`,
//             `${pathUrl}clear/nz.jpg`
//         ],
//     };
//
//     const loaderCubeTexture = new THREE.CubeTextureLoader();
//     const texture = lazyLoadingData(loaderCubeTexture, (action === 'BUILDING_ONLY') ? backgroundTexture.clear : backgroundTexture.current);
//     texture.then(img => {
//         threeJsVariables.scene.background = img;
//     });
// }

export function backgroundHide () {
    const {cylinderBg} = config.resources.background;

    if (cylinderBg && cylinderBg === 'sky'){

        let a = threeJsVariables.background //threeJsVariables.scene.getObjectByName('Background')
        if (!a){
            return
        }

        for (let i=0;i<a.children.length;i++){
            let c = a.children[i]

            gsap.to(c.material.uniforms.t, {
                duration: .6,
                value : 1.0,
                //onComplete: () => {}
            })
        }

    } else {

        const bg = threeJsVariables.scene.getObjectByName('Background');
        if (bg){
            if (!bg.visible){
                return;
            }

            bg.traverse(el=>{
                if (el.isMesh){

                    gsap.to(el.material, {
                        duration: .2,
                        transparent: true,
                        opacity: 0,

                        onComplete: () => {
                            bg.visible = false;
                        }
                    });

                }
            });
        }

    }


    /*
    const bg = threeJsVariables.scene.getObjectByName('Background');
    if (bg){
        if (!bg.visible){
            return;
        }

        bg.traverse(el=>{
            if (el.isMesh){

                gsap.to(el.material, {
                    duration: .2,
                    transparent: true,
                    opacity: 0,

                    onComplete: () => {
                        bg.visible = false;
                    }
                });

            }
        });
    }
    */
    // let a = threeJsVariables.background //threeJsVariables.scene.getObjectByName('Background')
    // if (!a){
    //     return
    // }
    //
    // for (let i=0;i<a.children.length;i++){
    //     let c = a.children[i]
    //
    //     gsap.to(c.material.uniforms.t, {
    //         duration: .6,
    //         value : 1.0,
    //         //onComplete: () => {}
    //     })
    // }
}

// export function backgroundShow () {
//     const bg = threeJsVariables.scene.getObjectByName('Background');
//     if (bg){
//         bg.visible = true;
//
//         bg.traverse(el=>{
//             if (el.isMesh){
//                 const bgPromise = new Promise(resolve => {
//                     gsap.to(el.material, {
//                         duration: 1,
//                         transparent: true,
//                         opacity: 1,
//
//                         onComplete: () => {
//                             el.material.transparent = false;
//                             resolve(true);
//                         }
//                     });
//                 });
//
//                 settingsData.animationsList.push(bgPromise);
//             }
//         })
//     }
// }

export function backgroundShow () {
    const animations = [];
    const {cylinderBg} = config.resources.background;

    if (cylinderBg && cylinderBg === 'sky'){

        let a = threeJsVariables.background
        if (!a){
            return
        }

        const {rotation} = config.resources.background
        a.rotation.set(rotation.x,rotation.y,rotation.z)

        for (let i=0;i<a.children.length;i++){
            let c = a.children[i]

            gsap.to(c.material.uniforms.t, {
                duration: 0.1,
                value : 0.0,
                //onComplete: () => {}
            })
        }

    } else {

        const bg = threeJsVariables.scene.getObjectByName('Background');
        if (bg){
            bg.visible = true;

            bg.traverse(el=>{
                if (el.isMesh){
                    const bgPromise = new Promise(resolve => {
                        gsap.to(el.material, {
                            duration: 1,
                            transparent: true,
                            opacity: 1,

                            onComplete: () => {
                                el.material.transparent = false;
                                resolve(true);
                            }
                        });
                    });

                    animations.push(bgPromise);
                }
            })
        }

    }


    /*

    const bg = threeJsVariables.scene.getObjectByName('Background');
    if (bg){
        bg.visible = true;

        bg.traverse(el=>{
            if (el.isMesh){
                const bgPromise = new Promise(resolve => {
                    gsap.to(el.material, {
                        duration: 1,
                        transparent: true,
                        opacity: 1,

                        onComplete: () => {
                            el.material.transparent = false;
                            resolve(true);
                        }
                    });
                });

               animations.push(bgPromise);
            }
        })
    }
    */



    return Promise.all(animations);
}

